import { useEffect, useState } from "react";
import { MyTypo, typographier } from "../../utils/typography/typographier";

function CardMobile5({ etirement }) {
  const [listItems, setListItems] = useState([]);

  useEffect(() => {
    function generateList() {
      if (etirement && Array.isArray(etirement.listes) && etirement.listes.length > 0) {
        const items = etirement.listes.map((value, key) => (
          <li key={key}>{typographier(value)}</li>
        ));

        setListItems(items);
      } else {
        setListItems([<li key="none"></li>]);
      }
    }

    generateList();
  }, [etirement]);

  return (
    //Ex cardQuaternaryy
    <div className="cardQuinary">
      <div className="cardQuinary-containerContains">
        <div className="cardQuinary-containerContains-containers1Img">
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet={etirement.coverDesktopXl}
              type="image/webp"
            />
            <source media="(min-width: 440px)" srcSet={etirement.coverTablette} type="image/webp" />
            <img src={etirement.coverMobile} alt={etirement.alt} />
          </picture>
        </div>
        <div className="cardQuinary-containerContains-containers1">
          <div className="cardQuinary-containerContains-containers1-description">
            <div className="cardQuinary-containerContains-containers1-description-titles">
              <h2 className="cardQuinary-containerContains-containers1-description-titles-title">
                {etirement.title}
              </h2>
            </div>
            <div className="cardQuinary-containerContains-containers1-description-subtitle">
              <p className="cardQuinary-containerContains-containers1-description-subtitle-paragraphe">
                {MyTypo(etirement.description1)}
              </p>
            </div>
            <div className="cardQuinary-containerContains-containers1-description-listes">
              <ul className="cardQuinary-containerContains-containers1-description-listes-liste">
                {listItems}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="cardQuinary-containerBackground"></div>
    </div>
  );
}

export default CardMobile5;
